module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-4.e3429de5.jpg";